export default {
  account: () => import("/opt/buildhome/repo/layouts/account.vue").then(m => m.default || m),
  admin: () => import("/opt/buildhome/repo/layouts/admin.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/opt/buildhome/repo/layouts/empty.vue").then(m => m.default || m),
  error: () => import("/opt/buildhome/repo/layouts/error.vue").then(m => m.default || m)
}